module.exports = __webpack_public_path__ + "static/media/boxing-gloves-4.3cda0f6c.png";